<div *ngIf="config$ | async as setting" class="config-panel">
  <h2 class="headline mb-4">
    <ic-icon [icon]="icSettings" class="mr-3" inline="true"></ic-icon>
    <span>{{ 'tasker.common.configuration' | translate }}</span>
  </h2>

  <div class="section">
    <h5 class="subheading">THEME STYLE</h5>

    <div *ngFor="let config of configs; let first = first"
         [class.mt-6]="!first"
         class="rounded">
      <div class="layout-image rounded overflow-hidden relative hover:bg-hover shadow-8">
        <img [src]="config.imgSrc" class="w-full block">
        <div class="layout-image-overlay" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px">
          <!-- <button (click)="setConfig(config.id, Style.light)"
                  class="bg-contrast-white text-contrast-black"
                  fxFlex="none"
                  mat-raised-button
                  type="button">SVĚTLÝ
          </button> -->
          <button (click)="setConfig(config.id, Style.default)"
                  color="primary"
                  fxFlex="none"
                  mat-raised-button
                  type="button">STANDARD
          </button>
          <!-- <button (click)="setConfig(config.id, Style.dark)"
                  class="bg-contrast-black text-contrast-white"
                  fxFlex="none"
                  mat-raised-button
                  type="button">TMAVÝ
          </button> -->
        </div>
      </div>
      <div class="text-center body-2 mt-2">{{ config.name }}</div>
    </div>
  </div>

  <div class="section">
    <h5 class="subheading">ROZVRŽENÍ</h5>

    <div class="section-content">
      <h5 class="subheading">ORIENTACE</h5>

      <mat-slide-toggle (change)="layoutRTLChange($event)" [checked]="isRTL$ | async">RTL</mat-slide-toggle>
    </div>
  </div>

  <div class="section">
    <h5 class="subheading">NÁSTROJE</h5>

    <div class="section-content">
      <h5 class="subheading">POZICE</h5>

      <mat-radio-group (change)="toolbarPositionChange($event)"
                       [value]="setting.toolbar.fixed ? 'fixed' : 'static'"
                       fxLayout="column"
                       fxLayoutGap="12px">
        <mat-radio-button value="fixed">Fixní</mat-radio-button>
        <mat-radio-button value="static">Statický</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="section">
    <h5 class="subheading">PATIČKA</h5>

    <div class="section-content">
      <mat-slide-toggle (change)="footerVisibleChange($event)" [checked]="setting.footer.visible">Zobrazit
      </mat-slide-toggle>

      <h5 class="subheading">Pozice</h5>

      <mat-radio-group (change)="footerPositionChange($event)"
                       [value]="setting.footer.fixed ? 'fixed' : 'static'"
                       fxLayout="column"
                       fxLayoutGap="12px">
        <mat-radio-button value="fixed">Fixní</mat-radio-button>
        <mat-radio-button value="static">Statická</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>
